<p>
  manage-mandanten-statistik works!
</p>
